import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class NATADetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-60 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  <h1 style={{fontSize: '30px'}}>Best NATA Coaching in Kodambakkam, Chennai</h1><br/>
				  <p>Do you have what it takes to be an architect? Then the NATA (National Aptitude Test in Architecture) is just the course for you from MIET, the <b> best NATA training centre in Chennai.</b> Conducted by the COA (Council of Architecture, India), NATA is an entrance to all B. Arch degree courses offered by all institutes and colleges of architecture in India. A one-day examination, held twice a year across the country, the exam is focused on assessing the aptitude of participants in drawings, observations, critical thinking, logical reasoning, and aesthetic sensitivity. The test occurs in two parts- a paper-based drawing test, and an MCQ-based online test.
                    </p><br/>
				  <p>At MIET, the best <b> NATA coaching institute in Chennai,</b> our comprehensive program covers everything from basic sketching and geometry to advanced design techniques. With expert guidance and personalized attention, we'll help you unlock your full potential and achieve your dream of becoming an architect.</p><br/>
				  <p><b>Ace your NATA exams with the best coaching classes in Chennai.</b></p>
				  <br/>
				  <p>MIET provides the best <b> NATA coaching classes in Chennai,</b> ensuring that students are equipped with the knowledge and skills needed to excel in their field of study. Enrol in our coaching classes today and achieve your dreams of becoming a successful architect!</p>
                    </ScrollAnimation>	
                    <ScrollAnimation animateIn="fadeInRight">
					<p>The <b>eligibility criteria</b> are as follows:</p>
                    <p><b>Qualifications: </b> Appearing in or have passed 12th (or equivalent) with Physics, Chemistry and Maths as compulsory subjects from a recognised board, or a 10+3 diploma with Maths as a compulsory subject.</p>
                    <p><b>Eligibility Marks (to appear for NATA): </b> At least 50% marks in Physics, Chemistry and Maths, and an overall aggregate of 50%, or 50% overall in 10+3 diploma.</p>
                    <p><b>Mode of Classes:</b> Offline, Online & Hybrid</p>
                    <p><b>Batches: </b> Regular, Evening & Weekend available.</p>
					
                    </ScrollAnimation>
               
                  <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
                        <h5 className="mb-0 mt-2">How does MIET, the best NATA coaching in Chennai help you crack NATA?</h5><br/>
							<p>The architecture combines technical and artistic approaches, and MIET, the best <b> NATA coaching center in Chennai</b> helps you with just the right amount of both.</p>
							
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Focus on the technical, engineering drawing, and sketching
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Analysing the correct views for different structures
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Focusing on technological and reasoning courses

								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Staying on top of paper patterns and syllabus
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" /> Complete study guide and experienced faculty support
								</li>
                                {/* <b>Not just theory, we help you gain practical skills too!</b> */}
							</ul>
                            <br/>
							<p>Get the edge you need to succeed with MIET's <b> NATA coaching in Chennai.</b> If you are looking to pursue a career in architecture, MIET's nata coaching program in Chennai will give you the knowledge and skills to succeed. With experienced faculty and a proven track record, you won't find a better program.</p><br/>
							<p>Sign up for MIET's nata coaching in Chennai today and take the first step towards a successful career in architecture.</p>
						</blockquote>
					</div>
					</ScrollAnimation>
                    <ScrollAnimation animateIn="fadeInRight">
				  	<div className='blog-details-page-content'>
					<blockquote>
						<h5 className="mb-0 mt-2">Application Form:</h5><br/>
						<Link to="/online-payment"><button className="btn btn-base" style={{color:'white',fontWeight:'700'}}>Visit</button></Link>
					</blockquote>
					</div>
					</ScrollAnimation>
                  </div>
		      </div>
			  <Sidebar courseRestriction="NATA" />
		    </div>
		  </div>
		</div>

        }
}

export default NATADetails